// src/components/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route/pathname changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // No UI, just behavior
};

export default ScrollToTop;